
<div class="ipm-forgot-password-section">
    <div class="ipm-heading-model-section">
        <h3> Forgot Password</h3>
        <div class="ipm-close-icon" (click)="closeByDeviceType()">
            <i class="pi pi-times"></i>
        </div>
    </div>
    <div class="ipm-forgot-password-body">
        <div class="error-message-data" *ngIf="shakeAnimation.errorMessage">
            {{shakeAnimation.errorMessage}}
        </div>
        <p class="ipm-sub-heading">
            If you have forgotten your password you can reset here
        </p>
        <ipm-login-signup [authType]="'forgot-password'" #forGotPassword>
            <div class="ipm-actions" actions>        
                <button mat-flat-button 
                        color="primary"
                        class="btn ipm-submit-btn"
                        type="submit"
                        (click)='sendPasswordResetLink(forGotPassword.authForm)'
                        [disabled]="!forGotPassword.authForm.valid">
                        Send Reset Link
                </button>
            </div>
        </ipm-login-signup>
    </div>
</div>

